import { render } from "./AccueilView.vue?vue&type=template&id=6253663a"
import script from "./AccueilView.vue?vue&type=script&lang=js"
export * from "./AccueilView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__